import React, { Component } from 'react';
import { Row, Col, Icon, BackTop } from 'antd';
import './App.css';

import BubbleCities from './components/BubbleCities/BubbleCities'
import VoronoiMigration from './components/VoronoiMigration/VoronoiMigration'
import DotMaps from './components/DotMaps/DotMaps'
import background from './assets/images/brusselsLines.png'
import LanguageSwitch from './components/LanguageSwitch/LanguageSwitch';
import { FormattedMessage } from 'react-intl';

var sectionStyle = {
  backgroundImage: `url(${background})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  backgroundPosition: 'right top',
  overflow: 'hidden',
  flex: '1 1 0%',
  height: '100vh',
  color: 'black',
};

const styles = {
  step: {
    fontFamily: 'Open Sans', 
    color: 'lightgrey',
    margin: '1rem 2rem 1rem 2rem',
    paddingTop: 50,
    width: '70%',
    pointerEvents: 'none',
  },
  p: {
    fontSize: 35, 
    fontFamily: 'Playfair Display', 
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    padding: '16px'
  },
  quoted: {
    color: 'lightgrey',
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    paddingLeft: '16px',
    paddingBottom: '16px'
  }
};

class App extends Component {
  render() {
    return (
      <div>
        <BackTop />
        <div style={sectionStyle}>
          <Row type="flex" justify="center" style={{height: '80vh'}}>
            <Col span={20} style={{ marginTop: '15vh', textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white', backgroundImage: 'linear-gradient( top, rgba( 255, 0, 255, 0 ) 0%, rgba( 255, 0, 255, 1 ) 100% )'}}>
              <div style={{fontSize: 80, fontFamily: 'Playfair Display', lineHeight: 1.2}}><FormattedMessage id="app.title1" /></div>
              <div style={{fontSize: 80, fontFamily: 'Playfair Display', lineHeight: 1.2}}><FormattedMessage id="app.title2" /></div>
              <Row type="flex" style={{ marginTop: 24 }}>
                <Col md={24} lg={12}>
                  <div><FormattedMessage id="app.subtitle" /></div>
                  <div style={{ marginTop: 16 }}><FormattedMessage id="app.languageSelection"/> <LanguageSwitch style={{ marginLeft: 16 }} /></div>
                </Col>
              </Row>
              <Row type="flex" style={{paddingLeft: '20vw', marginTop: '15vh'}}>
                <div style={{textAlign: 'center'}}>
                  <div><FormattedMessage id="app.scroll"/></div>
                  <div><Icon style={{ marginTop: 8, fontSize: '32px' }} type="down-circle" /></div>
                </div> 
              </Row>
            </Col>
          </Row>
          <div 
            style={{ 
              background: `linear-gradient(0deg, rgba(255,255,255,1), rgba(255,255,255,0))`,
              height: '20vh',
            }}/> 
        </div>
        <BubbleCities />
        <div style={{fontSize: 60, textAlign: 'center', fontFamily: 'Playfair Display', color: 'black', lineHeight: 1.2, paddingLeft: '10vw', paddingRight: '10vw'}}><FormattedMessage id="app.title3" /></div>
        <VoronoiMigration />
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1439.5 229.5" enableBackground="new 0 0 1439.5 229.5" xmlSpace="preserve">
          <polygon fill="#2a2a2a" points="1440.5,230 0,229.5 1440,-0.5"></polygon>
        </svg>
        <div style={{ backgroundColor: '#2a2a2a', marginTop: -6, marginBottom: -1 }}>
          <div style={{fontSize: 60, textAlign: 'center', fontFamily: 'Playfair Display', color: 'white', lineHeight: 1.2, marginBottom: 64 }}><FormattedMessage id="app.title5"/></div>
          <DotMaps />
          <Row type="flex">
            <Col sm={{ span: 24 }} md={{ span: 12 }}>
              <img alt="map" style={{width: "100%"}} src={require(`./assets/images/dotmaps/mix.png`)}/>
            </Col>
            <Col sm={{ span: 24 }} md={{ span: 12 }}>
              <div style={styles.step}>
                <div style={styles.p}>
                  <FormattedMessage id="app.title6"/>
                </div>
                <h4 style={{ ...styles.quoted }}>
                  <FormattedMessage id="app.title7" values={{ 
                    na: <strong style={{ color: '#F50057' }}><FormattedMessage id="region.northAfrica" /></strong>,
                    t: <strong style={{ color: '#FFEA00' }}><FormattedMessage id="region.turkey" /></strong>,
                    eu: <strong style={{ color: '#00B0FF' }}><FormattedMessage id="region.eu15" /></strong> }}
                  />
                </h4>
              </div>
            </Col>
          </Row>
        </div>
        <svg style={{ marginLeft: -1 }} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1439.5 229.5" enableBackground="new 0 0 1439.5 229.5" xmlSpace="preserve">
          <polygon fill="#2a2a2a" transform="translate(720, 115) scale(-1, -1) translate(-720, -115) " points="1440.5 231 0 230.5 1440 0.5"></polygon>
        </svg>
        <Row type="flex">
          <Col sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4}} style={{ paddingLeft: '10vw', paddingRight: '10vw'}}>
            <div style={{fontSize: 60, fontFamily: 'Playfair Display', lineHeight: 1.2, marginBottom: 16}}><FormattedMessage id="app.title8" /></div>
            <p>
              <FormattedMessage id="app.title9" /><br/><FormattedMessage id="app.title10" />
            </p>
            <p><FormattedMessage id="app.title11" />:</p>
            <ul>
              <li>
                <FormattedMessage id="app.title12" />
              </li>
              <li>
                <FormattedMessage id="app.title13" />
              </li>
              <li>
                <FormattedMessage id="app.title14" />
              </li>
            </ul>
            <p><FormattedMessage id="app.title15" /> http://brussels-diversity.jetpack.ai</p>
            <Row type="flex" justify="end">
              <img alt="map" style={{marginLeft: 8, marginRight: 8, width: 120}} src={require(`./assets/images/Jetpack-small.png`)}/>
            </Row>
          </Col>
        </Row>
        <div style={{ height: 250}} />
      </div>
    );
  }
}

export default App;
